<script>
    
    import ConnectivityCheck from '@src/components/ConnectivityCheck.svelte'
    import {locale, language } from '@src/languages.js'
    import routerManager from '@src/router/router'
    
    const router = routerManager.getRouter('default')
    let canGoBack = false
    router.subscribe(e=>{
        canGoBack = router.getState().name != 'home'
    })    

    
    
    function goBack(){
        try{            
            window.history.back()            
        }catch(err){
            console.log(err)
        }
    }
</script>
<header class=" text-blak border-b-2 border-green-500 text-green-500">
<div class="flex flex-row p-2">
    <button class:invisible={!canGoBack} class="p-2"
        on:click={goBack}>
            {#if $locale == 'ar' }
                <svg viewBox="0 0 15 15" fill="none" xmlns="http://www.w3.org/2000/svg" width="15" height="15"><path d="M13.5 7.5l-4-4m4 4l-4 4m4-4H1" stroke="currentColor"></path></svg>

            {:else }
                <svg viewBox="0 0 15 15" fill="none" xmlns="http://www.w3.org/2000/svg" width="15" height="15"><path d="M1.5 7.5l4-4m-4 4l4 4m-4-4H14" stroke="currentColor"></path></svg>
            {/if}    
        </button>
    <h1 class="text-lg font-bold text-center w-full">{ $language.app_title } </h1>
</div>
<ConnectivityCheck/>
</header>